import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { downloadFile } from '../../actions/fileDownloads';
import { joinClassNames } from '../../utils';

DownloadButton.propTypes = {
    urlPath: PropTypes.string.isRequired,
    errorMessageKeys: PropTypes.shape({
        unauthorized: PropTypes.string,
        failed: PropTypes.string,
    }).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    data: PropTypes.object,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    className: PropTypes.string,
};

function DownloadButton(props) {
    const {
        urlPath,
        errorMessageKeys,
        data = null,
        disabled = false,
        label = null,
        className = '',
    } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onDownload = () => dispatch(downloadFile(urlPath, data, errorMessageKeys));
    return (
        <button
            disabled={disabled}
            className={joinClassNames(className, 'button', 'button-bordered', 'download-button')}
            type="button"
            onClick={onDownload}
            onKeyUp={onDownload}
        >
            <FontAwesomeIcon icon="download" />&nbsp;{label || t('button.download')}
        </button>
    );
}

export default DownloadButton;
